<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener('DOMContentLoaded', function() {
  var selector = ".about-title, .header-special, .halo-block-header .title .text, .halo-recommendations-block .title .text, .halo-recently-viewed-block-sections .title .text, .productView-title, .page-header, .banner-item .banner-heading";
  var elements = document.querySelectorAll(selector);
  
  if( elements ){
    maxWidth = window.screen.width - 20;
    elements.forEach(element => {
       if (element.scrollWidth > maxWidth) {
        var scale = maxWidth / element.scrollWidth  ;
        // Apply the scale transformation to the element
        element.style.transformOrigin = 'left top';
        element.style.transform = 'scale(' + scale + ')';
      }
    });
  }
  
});


$(document).ready(function() {
    if (window.location.href.indexOf('newsletter&form_type=customer') > -1) {
        var newsletterSuccessPopup = (function() {
            var popup = $('.newsletter-success-modal');
            var close = popup.find('.close');
            var success = popup.find('.success');
            var error = popup.find('.error');
            var overlay = $('.background-overlay');
            popup.show();
            overlay.show();
            error.show();
            success.hide();
            $.cookie('emailSubcribeModal', 'closed', {
                expires: 1,
                path: '/'
            });
            close.off('click').on('click', function() {
                popup.fadeOut();
                overlay.hide();
            });
            overlay.off('click').on('click', function() {
                popup.fadeOut();
                overlay.hide();
            });
        })();
        var newURL = location.href.split("?")[0];
        window.history.pushState('object', document.title, newURL);
    }
})